import { useTranslation } from 'react-i18next';
import { AvailableLanguages } from '../enum/AvailableLanguages';
import { languageLocales } from '../util/languageLocales';

/** 
 * useLanguageLocale - Custom React hook that returns the localization 
 * settings for the currently selected language in the application.

 * It integrates with i18next (react-i18next) to automatically determine
 * the current language and returns the corresponding locale data 
 * from the centralized languageLocales map.

 * Behavior:
 *   - Reads the current language from i18n.language
 *   - Maps it to the corresponding locale in languageLocales
 *   - Defaults to AvailableLanguages.ENG if the current language is not found

 * Advantages:
 *   - Centralizes locale logic in a single hook
 *   - Automatically updates when i18next language changes
 *   - Type-safe integration with AvailableLanguages enum
*/

export const useLanguageLocale = () => {
  const { i18n } = useTranslation();

  const lang = i18n.language as AvailableLanguages;
  const locale = languageLocales[lang as keyof typeof languageLocales] || languageLocales[AvailableLanguages.ENG];

  return locale;
};
